import type {LabelColorOptions} from '@primer/react'

// Allowlist of categorical cell values that should render as a Primer `Label`.
// Keys are lowercase trimmed. Single-word keys match per token (cells split on
// whitespace and on `-`, `/`, `+`, `,`, `&`, `()`), so they fire for compounds
// like `Low-Medium`. Multi-word keys (e.g. `in progress`) are matched via
// direct lookup before tokenization. Polarity is not inferred: `Low` is always
// `success` regardless of whether low is good or bad in context.
export const VALUE_TO_VARIANT: Record<string, LabelColorOptions> = {
  // Severity
  low: 'success',
  medium: 'attention',
  high: 'severe',
  critical: 'danger',

  // Severity intensifiers / qualifiers (commonly appear in compounds)
  minor: 'success',
  moderate: 'attention',
  major: 'severe',
  extreme: 'danger',
  severe: 'severe',

  // Boolean
  yes: 'success',
  no: 'danger',
  true: 'accent',
  false: 'default',

  // Pass/fail
  pass: 'success',
  passed: 'success',
  fail: 'danger',
  failed: 'danger',
  error: 'danger',
  success: 'success',
  successful: 'success',
  warning: 'attention',

  // On/off, enabled state
  on: 'success',
  off: 'danger',
  enabled: 'success',
  disabled: 'danger',
  active: 'success',
  inactive: 'danger',
  available: 'success',
  unavailable: 'danger',
  supported: 'success',
  unsupported: 'danger',

  // Lifecycle / status
  ready: 'success',
  pending: 'attention',
  blocked: 'danger',
  approved: 'success',
  rejected: 'danger',
  complete: 'success',
  completed: 'success',
  done: 'done',
  draft: 'default',
  open: 'accent',
  closed: 'default',
  merged: 'done',
  new: 'accent',
  archived: 'default',
  deprecated: 'attention',
  stable: 'success',
  unstable: 'attention',
  experimental: 'attention',
  beta: 'accent',
  alpha: 'attention',
  partial: 'attention',
  degraded: 'attention',

  // Recommendation
  recommended: 'success',
  preferred: 'success',
  best: 'success',
  worst: 'danger',
  avoid: 'danger',

  // Info / neutral
  info: 'accent',
  'n/a': 'default',
  unknown: 'default',
  none: 'default',
  tbd: 'default',

  // Multi-word fast-path entries (matched against the full trimmed cell text
  // before tokenization).
  'in progress': 'attention',
  'in-progress': 'attention',
  'not started': 'default',
  'not-started': 'default',
  'on hold': 'attention',
  'on-hold': 'attention',
  'up to date': 'success',
  'up-to-date': 'success',
  'out of date': 'attention',
  'out-of-date': 'attention',
  'very low': 'success',
  'very high': 'severe',
}
